module.exports = __webpack_public_path__ + "static/image10-38262ea002578e0632e7b5c0645a46fc.jpeg";